<template>
  <div>
    <v-row>
      <v-col class="pb-0">
        <div class="subtitle-1 text-left">Microcredential Settings</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-sm-7 pb-0">
        <div>
          <v-select
            id="microcredentialServiceSelect"
            v-model="microcredentialService"
            @change="handleUpdateBadgeEnabled"
            label="Microcredential Service"
            class="mr-2"
            :items="microcredentialProviders"
            :color="playlistColor"
            :disabled="isUpdating || restrictPlaylistAccess">
          </v-select>
        </div>
      </v-col>
    </v-row>
    <BadgrSettings
      v-if="microcredentialService === 'Badgr'"
    ></BadgrSettings>
    <CredlySettings
      v-if="microcredentialService === 'Credly'"
    ></CredlySettings>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
} from 'vuex';
import { mapFields } from 'vuex-map-fields';

import _ from 'lodash';
import BadgrSettings from './BadgrSettings.vue';
import CredlySettings from './CredlySettings.vue';

export default {
  name: 'MicroCredentialSettings',
  components: {
    BadgrSettings,
    CredlySettings,
  },
  data: () => ({
    microcredentialProviders: ['None'],
    playlistColor: null,
  }),
  computed: {
    ...mapState([
      'badgrLoaded',
      'credlyLoaded',
      'courseHash',
      'isLoaded',
      'isLti',
      'isUpdating',
      'microcredentialService',
      'playlist',
      'sectionId',
      'user',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
    ...mapFields([
      'microcredentialService',
    ]),
  },
  methods: {
    ...mapMutations([
      'setBadgrLoaded',
      'setCredlyLoaded',
      'setIsUpdating',
      'toggleSnackbar',
    ]),
    async handleUpdateBadgeEnabled() {
      try {
        // If there is a badge added to playlist and instructor selects 'None' for badge service - deactivate badge
        if (
          this.badgrLoaded
          || this.setCredlyLoaded
        ) {
          this.setIsUpdating(true);
          await this.$api.playlist.disableBadge({
            enableBadge: this.microcredentialService !== 'None',
            playlistId: this.playlist.id,
          });
        }
      } catch(e) {
        this.toggleSnackbar({
          text: 'Error deactivating badge.',
          color: 'error',
          timeout: 2500,
        });
      } finally {
        this.setIsUpdating(false);
      }
    },
  },
  async beforeMount() {
    if (this.user.school && _.get(this.user.school, 'badgr.enabled', false)) {
      this.microcredentialProviders.push('Badgr');
    }
    if (
      this.user.school
      && this.user.school.credentials
      && _.find(this.user?.school?.credentials, { type: 'credly' })
    ) {
      this.microcredentialProviders.push('Credly');
    }
  },
  async mounted() {
    /*
      The default_color is set to a standard hex color (#2196F3) by default as it is the only way to remove
      the transparency picker from the Vuetify color picker.  Then on mounted we update it to the stored
      value from the DB
    */
    this.playlistColor = _.get(this, 'playlist.default_color') ? this.playlist.default_color : '#2196F3';
    if (_.get(this.playlist, 'badge.credly.badge', false)) {
      this.microcredentialService = 'Credly';
      this.setCredlyLoaded(true);
    }
    if (_.get(this.playlist, 'badge.badgr.badge', false)) {
      this.microcredentialService = 'Badgr';
      this.setBadgrLoaded(true);
    }
  },
};
</script>
